/**
 * Application state management
 */

export class AppState {
  constructor() {
    this.users = [];
    this.artists = [];
    this.djs = [];
    this.drawMode = 'playcount'; // or 'playRank'
    this.maxPlaycount = 20;
    this.targetMaxPlaycount = 20;
    this.maxPlayRank = 1;
    this.slowFrameCount = 0;
    this.newPinnedNode = false;
    this.zoomScale = 1;
    this.dragNode = null;
    this.dragStart = null;

    // Date range for charts
    const startDate = new Date();
    startDate.setFullYear(startDate.getFullYear() - 1);
    this.startDate = startDate;
    this.endDate = new Date();
  }

  /**
   * Add a user to the state
   * @param {Object} user - User data
   */
  addUser(user) {
    this.users.push(user);
    this.updateURL();
  }

  /**
   * Remove a user by ID
   * @param {number} userId - User ID to remove
   */
  removeUser(userId) {
    const index = this.users.findIndex(u => u.id === userId);
    if (index !== -1) {
      this.users.splice(index, 1);
      this.updateURL();
    }
  }

  /**
   * Find user by name
   * @param {string} name - Username
   * @returns {Object|undefined} User object or undefined
   */
  findUser(name) {
    return this.users.find(u => u.name === name);
  }

  /**
   * Add an artist to the state
   * @param {Object} artist - Artist data
   */
  addArtist(artist) {
    this.artists.push(artist);
  }

  /**
   * Find artist by ID
   * @param {number} id - Artist ID
   * @returns {Object|undefined} Artist object or undefined
   */
  findArtist(id) {
    return this.artists.find(a => a.id === id);
  }

  /**
   * Set DJs
   * @param {Array} djList - Array of DJ objects
   */
  setDJs(djList) {
    this.djs = djList;
  }

  /**
   * Update browser URL with current users
   */
  updateURL() {
    const userStr = this.users.map(u => u.name).join(',');
    if (userStr) {
      window.history.pushState(null, null, `?users=${userStr}`);
    }
  }

  /**
   * Toggle draw mode
   */
  toggleDrawMode() {
    this.drawMode = this.drawMode === 'playcount' ? 'playRank' : 'playcount';
    return this.drawMode;
  }
}
